import axios from 'axios';

const API_BASE_URL = 'https://vitaldev.vitalinsights.in';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const patientManagementService = {
  // Fetch all profiles and handle local search/pagination
  getProfilesList: async (page = 1, limit = 10, search = '') => {
    try {
      // Fetch all profiles with limit 1000
      const response = await api.get('/user/goals/list', {
        params: {
          page: 1,
          limit: 10000
        }
      });

      // Extract profiles from response - handle both nested and direct data
      let allProfiles = response.data?.data || response.data || [];

      // Local search filtering
      if (search) {
        const searchLower = search.toLowerCase();
        allProfiles = allProfiles.filter((profile) => {
          const name = (profile.name || '').toLowerCase();
          const phone = (profile.phone || '').toLowerCase();
          return name.includes(searchLower) || phone.includes(searchLower);
        });
      }

      // Calculate pagination
      const totalProfiles = allProfiles.length;
      const totalPages = Math.ceil(totalProfiles / limit) || 1;
      const startIndex = (page - 1) * limit;
      const endIndex = startIndex + limit;
      const paginatedProfiles = allProfiles.slice(startIndex, endIndex);

      return {
        data: paginatedProfiles,
        pagination: {
          total: totalProfiles,
          page,
          limit,
          totalPages
        }
      };
    } catch (error) {
      console.error('Error fetching profiles:', error);
      throw error;
    }
  },

  // Start a goal for a profile
  startGoal: async (profileId, goalId) => {
    try {
      const response = await api.post('/user/goals/start', {
        profile_id: profileId,
        goal_id: goalId
      });
      return response.data;
    } catch (error) {
      console.error('Error starting goal:', error);
      throw error;
    }
  },

  // End a goal for a profile
  endGoal: async (profileId) => {
    try {
      const response = await api.post('/user/goals/end', {
        profile_id: profileId
      });
      return response.data;
    } catch (error) {
      console.error('Error ending goal:', error);
      throw error;
    }
  },

  // Fetch all health goals for the dropdown
  getAllHealthGoals: async () => {
    try {
      const response = await api.get('/health/health-goals');
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching health goals:', error);
      throw error;
    }
  }
};
